<template>
  <Link
    class="block h-full"
    :href="route('frontend.theme-auctions.show', {themeAuction: auction.theme_auction.slug, highlight: auction.slug})"
  >
    <div class="flex flex-col h-full bg-white rounded overflow-clip">
      <div class="relative">
        <img
          class="min-w-full"
          :alt="auction.name"
          :src="auction.main_image_big"
        >
        <template v-if="auction.customer_has_highest_bid">
          <i
            class="fa fa-crown text-yellow-400 text-3xl absolute top-3 right-3 rotate-[22deg]"
            title="Jij hebt het hoogste bod!"
          />
        </template>
      </div>
      <div class="flex flex-col justify-between grow px-3 pt-2 pb-1 border-1 border-top border-gray-500">
        <div class="text-lg md:text-xl mb-2">
          {{ auction.name }}
        </div>
        <div class="flex flex-col-reverse md:flex-row items-end justify-between space-x-1">
          <time
            class="text-xs text-gray-500 uppercase whitespace-nowrap"
            :datetime="auction.auction_ends_at"
          >
            {{ auction.auction_ends_at }}
          </time>
          <div class="shrink-0 mb-2 md:mb-0 font-bold text-3xl/7 text-sky-400">
            {{ formatMoney(auction.price) }}
          </div>
        </div>
      </div>
      <div class="px-3 pt-3 pb-2 bg-sky-600">
        <div class="font-bold text-center md:text-left text-xl md:text-2xl text-white uppercase">
          Bekijk kavel
        </div>
      </div>
    </div>
  </Link>
</template>

<script>
import {Link} from '@inertiajs/vue2';

export default {
  components: {Link},

  props: {
    auction: {
      required: true,
      type: Object,
    },
  },
};
</script>
